import './scss/style.scss';
import _ from 'lodash';
import React from 'react';
import toastr from 'toastr';

global._ = _;
global.React = React;

window.onerror = window.onunhandledrejection = error;
window.addEventListener('unhandledrejection', error);
function error(e) {
	let message = (
		(e && e.stack) ||
		(e && e.reason && e.reason.stack) ||
		(e && e.reason) ||
		(e)
	);
	if (typeof console !== 'undefined') console.error(message);
	toastr.error(String(message), 'An error occured!', { timeOut: 100000000 });
}




// WEBPACK FOOTER //
// ./admin/shared.js